<template>
    <div class='adchannelManager'>
        <div class="planlist">
            <!-- <el-row style="margin-bottom:1rem">
                <el-col :span="24" style="text-align:left">
                    <el-input style="width:200px;" v-model="paginationInfo.condition.mobile" maxlength="11"
                        placeholder="请输入手机号" clearable></el-input>
                    <el-date-picker v-model="paginationInfo.condition.begin_date" align="right" type="date"
                        placeholder="选择开始时间" :picker-options="{
                            disabledDate(time) {
                                return time.getTime() > Date.now();
                            },
                        }">
                    </el-date-picker>
                    <el-date-picker v-model="paginationInfo.condition.end_date" align="right" type="date"
                        placeholder="选择结束时间" :picker-options="{
                            disabledDate(time) {
                                return time.getTime() > Date.now();
                            },
                        }">
                    </el-date-picker>
                    <el-select v-model="paginationInfo.condition.app_code" placeholder="请选择订单状态" @change="queryList"
                        filterable clearable>
                        <el-option label="language会员" value="languagemember"></el-option>
                        <el-option label="冰蓝科技" value="blkjwechatpay"></el-option>
                        <el-option label="陀螺领购" value="tllgwechatpay"></el-option>
                    </el-select>
                    <el-button @click="queryList">查询</el-button>
                </el-col>
            </el-row> -->
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="name" label="渠道名称" align='center' width="150">
                </el-table-column>
                <el-table-column prop="code" label="渠道编码" align='center'>
                </el-table-column>
                <el-table-column label="支付账户设置">
                    <template slot-scope="scope">
                        <div v-html="filterAccountInfo(accountRules[scope.row.code], accountNameMappings)"></div>
                        <el-button v-if="accountRules[scope.row.code] && scope.row.code !=='DEFAULT'" size="mini" type="primary" @click="handleAccountRuleFormVisable(accountRules[scope.row.code], scope.row.name)">账户配置</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="pass" label="回传数量" align='center'>
                </el-table-column>
                <el-table-column prop="skip" label="扣单数量" align='center'>
                </el-table-column>
                <el-table-column prop="skip_percent" label="扣单比例" align='center' width="300">
                    <template slot-scope="scope">
                        <div>
                            {{ Math.floor(scope.row.skip_percent * 100) + '%' }}
                            <el-button type="primary" plain @click="handleItemSkipPercent('show', scope.row)"
                                size="mini">修改扣单比例</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="total" label="总数" align='center'>
                </el-table-column>
                <el-table-column  label="操作" align='center'>
                    <template slot-scope="scope">
                        <div>
                            <el-button type="warning" plain @click="handleNextFillInAccount(scope.row)"
                                size="mini">下一单指定账号</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog title="修改扣单比例" :visible.sync="handleSkipPercentType" width="30%" :before-close="handleClose">
                <div>
                    <el-select v-model="formData.skip_percent" placeholder="请选择">
                        <el-option v-for="item in skipPercentOptions" :key="item" :label="`${Math.floor(item * 100)}%`"
                            :value="item">
                        </el-option>
                    </el-select>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleSkipPercentType = false">取 消</el-button>
                    <el-button type="primary" @click="handleItemSkipPercent('handle')">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="下一单指定账号" :visible.sync="nextFillInVisable" width="30%">
                <div>
                    <el-select v-model="nextFillInForm.app_code" placeholder="请选择">
                        <el-option v-for="item in accountChannelList" :key="item.dictdata_value"
                            :label="item.dictdata_name" :value="item.dictdata_value" />
                    </el-select>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="nextFillInVisable = false">取 消</el-button>
                    <el-button type="primary" @click="confirmNextFillInAccount">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog :title="'账户配置 - ' + accountRuleForm.channel_name" :visible.sync="accountRuleFormVisable" width="30%">
                <div>
                    <el-form>
                        <el-form-item label="网页支付">
                            <el-select v-model="accountRuleForm.PAY" placeholder="请选择">
                                <el-option v-for="item in accountChannelList" :key="item.dictdata_value"
                                    :label="item.dictdata_name" :value="item.dictdata_value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="授权支付">
                            <el-select v-model="accountRuleForm.FREEZE" placeholder="请选择">
                                <el-option v-for="item in accountChannelList" :key="item.dictdata_value"
                                    :label="item.dictdata_name" :value="item.dictdata_value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="APP支付">
                            <el-select v-model="accountRuleForm.APP" placeholder="请选择">
                                <el-option v-for="item in accountChannelList" :key="item.dictdata_value"
                                    :label="item.dictdata_name" :value="item.dictdata_value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="二维码支付">
                            <el-select v-model="accountRuleForm.ALIPAY_QRCODE" placeholder="请选择">
                                <el-option v-for="item in accountChannelList" :key="item.dictdata_value"
                                    :label="item.dictdata_name" :value="item.dictdata_value" />
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="accountRuleFormVisable = false">取 消</el-button>
                    <el-button type="primary" @click="handleAccountRuleFormSubmit">确 定</el-button>
                </span>
            </el-dialog>
            <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="paginationInfo.pageNo" :page-sizes="[10, 20, 50, 100]"
                :page-size="paginationInfo.pageSize" :total="paginationInfo.total"
                layout="total, sizes, prev, pager, next, jumper">
            </el-pagination> -->
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            handleSkipPercentType: false,
            nextFillInVisable: false,
            accountRuleFormVisable: false,
            accountChannelList: [],
            skipPercentOptions: [0.00, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.8, 0.9],
            paginationInfo: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
                condition: {
                    // begin_date: "",
                    // end_date: "",
                    // app_code: "languagemember",
                    // mobile: '',
                    // status: '',
                }
            },
            formData: {
                skip_percent: ""
            },
            nextFillInForm: {
                app_code: '',
                channel_code: ''
            },
            tableData: [],
            accountRules: {},
            accountNameMappings: {},
            accountRuleForm: {
                id: '',
                dictdata_name: '',
                channel_name: '',
                PAY: '',
                FREEZE: '',
                APP: '',
                PAY_TYPE: '',
                ALIPAY_QRCODE: ''
            }
        }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.getAccountChannel()
            .then(() => {
                return this.getPayAccountRules()
            })
            .then(() => {
                this.queryList();
            })
    },
    methods: {
        handleAccountRuleFormVisable(dict, name) {
            this.accountRuleFormVisable = true
            dict.dictdata_object = dict.dictdata_object || {}
            this.accountRuleForm.id = dict._id
            this.accountRuleForm.channel_name = name
            this.accountRuleForm.dictdata_name = dict.dictdata_name
            this.accountRuleForm.PAY = dict.dictdata_object.PAY
            this.accountRuleForm.FREEZE = dict.dictdata_object.FREEZE
            this.accountRuleForm.APP = dict.dictdata_object.APP
            this.accountRuleForm.PAY_TYPE = dict.dictdata_object.PAY_TYPE
            this.accountRuleForm.ALIPAY_QRCODE = dict.dictdata_object.ALIPAY_QRCODE
        },
        handleAccountRuleFormSubmit() {
            this.$service.CommonService
                .updateDictDataObject(this.accountRuleForm.id, {
                    dictdata_name: this.accountRuleForm.dictdata_name,
                    dictdata_object: {
                        PAY : this.accountRuleForm.PAY,
                        FREEZE : this.accountRuleForm.FREEZE,
                        APP: this.accountRuleForm.APP,
                        ALIPAY_QRCODE: this.accountRuleForm.ALIPAY_QRCODE,
                        PAY_TYPE : this.accountRuleForm.PAY_TYPE,
                    }
                })
                .then(res => {
                    if (res.data.code === 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.accountRuleFormVisable = false
                        this.getPayAccountRules()
                            .then(() => {
                                this.queryList()
                            })
                        this.$service.OnlineOrderService.reloadAccountMapping()
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'warning'
                        });
                    }
                })
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    done();
                })
                .catch(() => { });
        },
        handleItemSkipPercent(type, item) {
            switch (type) {
                case "show":
                    this.handleSkipPercentType = true;
                    this.formData.skip_percent = item.skip_percent;
                    this.formData._id = item._id;
                    break;
                case "handle":
                    this.$service.OnlineOrderService
                        .getAdchannelManagerRulesReset(this.formData)
                        .then(res => {
                            if (res.data.code === 0) {
                                this.handleSkipPercentType = false;
                                this.getAdchannelManagerRules();
                                this.$message({
                                    message: '修改成功！',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    message: res.data.message,
                                    type: 'error'
                                });
                            }
                        }).catch((err) => {
                            window.console.log(err)
                            this.$message({
                                message: '网络错误，请重新修改！',
                                type: 'error'
                            });
                        })
                    break;

            }
        },
        queryList() {
            this.paginationInfo.pageNo = 1;
            this.getAdchannelManagerRules();
        },
        handleSizeChange(val) {
            window.console.log(`每页 ${val} 条`);
            this.paginationInfo.pageSize = val;
            this.paginationInfo.pageNo = 1;
            this.getAdchannelManagerRules();
        },
        handleCurrentChange(val) {
            window.console.log(`当前页: ${val}`);
            this.paginationInfo.pageNo = val;
            this.getAdchannelManagerRules();
        },
        handleNextFillInAccount(row) {
            this.nextFillInForm.channel_code = row.code
            this.nextFillInVisable = true
        },
        confirmNextFillInAccount() {
            if(!this.nextFillInForm.channel_code) {
                return
            }
            if(!this.nextFillInForm.app_code) {
                this.$message({
                    message: '请选择账号',
                    type: 'success'
                });
                return
            }
            this.$service.OnlineOrderService
                .setFillInStandBy({
                    channel_code: this.nextFillInForm.channel_code,
                    app_code: this.nextFillInForm.app_code
                })
                .then(res => {
                    if (res.data.code === 0) {
                        this.$message({
                            message: '已提交',
                            type: 'success'
                        });
                        this.nextFillInVisable = false
                    }
                })
        },
        getAccountChannel() {
            return new Promise((resolve, reject) => {
                this.$service.CommonService
                    .getDict({ dict: 'AlipayAccountOptions' })
                    .then(res => {
                        if (res.data.code === 0) {
                            this.accountChannelList = res.data.data.dict_data;
                            this.accountChannelList.forEach(item => {
                                this.accountNameMappings[item.dictdata_value] = item.dictdata_name
                            })
                            resolve()
                        } else {
                            reject()
                        }
                    })
                    .catch(reject)
            })
        },
        getAdchannelManagerRules() {
            this.$service.OnlineOrderService
                .getAdchannelManagerRules({
                    pageNo: 1,
                    pageSize: 9999
                })
                .then(res => {
                    if (res.data.code === 0) {
                        this.tableData = res.data.data.rules;
                        this.tableData.forEach(item => {
                            item.handleSkipPercentType = false;
                        });
                    }
                })
        },
        getPayAccountRules() {
            return new Promise((resolve, reject) => {
                this.$service.OnlineOrderService
                    .getPayAccountRules()
                    .then(res => {
                        if (res.data.code === 0) {
                            res.data.data.dict_data.forEach(item => {
                                this.accountRules[item.dictdata_name] = item
                            })
                            resolve()
                        } else {
                            reject()
                        }
                    })
                    .catch(reject)
            })
        },
        filterAccountInfo(value, accountNameMappings) {
            if (!value) return ''
            if (!value.dictdata_object) return value.dictdata_value
            const accountRuleStr = []
            if(value.dictdata_object.PAY) {
                accountRuleStr.push('网页支付：' + accountNameMappings[value.dictdata_object.PAY] || value.dictdata_object.PAY)
            }
            if(value.dictdata_object.FREEZE) {
                accountRuleStr.push('签约支付：' + accountNameMappings[value.dictdata_object.FREEZE] || value.dictdata_object.FREEZE)
            }
            if(value.dictdata_object.APP) {
                accountRuleStr.push('APP支付：' + accountNameMappings[value.dictdata_object.APP] || value.dictdata_object.APP)
            }
            if(value.dictdata_object.ALIPAY_QRCODE) {
                accountRuleStr.push('二维码支付：' + accountNameMappings[value.dictdata_object.ALIPAY_QRCODE] || value.dictdata_object.ALIPAY_QRCODE)
            }
            return accountRuleStr.join('<br />')
        }
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { } // 如果页面有keep-alive缓存功能,这个函数会触发
}
</script>
